import React from "react";
import {
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Bar,
  BarChart,
  Legend,
} from "recharts";

function TasksChart() {
  const taskChartData = [
    { month: "January", committed: 20, completed: 15 },
    { month: "February", committed: 25, completed: 18 },
    { month: "March", committed: 30, completed: 20 },
    { month: "April", committed: 28, completed: 22 },
    { month: "May", committed: 35, completed: 30 },
    { month: "June", committed: 40, completed: 35 },
    { month: "July", committed: 45, completed: 40 },
    { month: "August", committed: 50, completed: 45 },
    { month: "September", committed: 55, completed: 50 },
  ];

  return (
    <div className="h-[22rem] bg-white p-4 rounded-lg flex flex-col flex-1">
      <strong className="text-lg">Commited and Completed Tasks</strong>
      <div className="w-full mt-3 flex-1">
        <ResponsiveContainer width="100%">
          <BarChart data={taskChartData}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip wrapperStyle={{}} />
            <Legend />
            <Bar dataKey="committed" name="Committed" fill="#9999ff" />
            <Bar dataKey="completed" name="Completed" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default TasksChart;
